<template>
  <div v-reportView:toast="{ actiontype: 1, toast: 'set', click: 0 }" class="tools_setting_content">
    <div class="cache_box">
      <div class="cache_size">
        <h5 class="label">缓存大小：</h5>
        <p class="value">{{ cacheSize || '0B' }}</p>
      </div>
      <div>
        <Button class="cache_btn" @click="openCacheDir">缓存目录</Button>
        <Button @click="clearCache">清除缓存</Button>
      </div>
    </div>

    <div class="sys_switch">
      <h3 class="title">侧边栏</h3>
      <div class="switch_item">
        <div class="switch_box">
          <Checkbox
            :status="switchValue[switchKey.full]" :disable="switchValue.fullDisable" color="theme"
            @select="setSwitchState" />
        </div>
        <p>关闭启动Office时自动展开侧边栏</p>
      </div>
      <div class="switch_item">
        <div class="switch_box">
          <Checkbox
            :status="switchValue[switchKey.sidebar]" :disable="switchValue.sidebarDisable" color="theme"
            @select="setCloseSwitchState" />
        </div>
        <p>永久关闭侧边栏</p>
      </div>

      <h3 class="title">Office插件设置</h3>
      <div class="switch_item">
        <div class="switch_box">
          <Checkbox :status="switchValue[switchKey.addin]" color="theme" @select="setCloseOfficeSwitchState" />
        </div>
        <p>永久关闭办公模板Office插件</p>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button/index.vue'
import Checkbox from '@/components/Checkbox/index.vue'

import { bytesToSize } from '@shared/utils/base'

import {
  ClientGetCacheSize, ClientOpenCachePath, ClientClearCache,
  ClientSetOfficeAddIn, ClientGetOfficeSetting
} from '@/api/clientApi.js'
import { switchKey } from '@/common/const.js'
import { report } from '@/report/index.js'

export default {
  name: 'ToolsSetting',

  components: { Button, Checkbox },

  data () {
    return {
      switchKey,
      switchValue: {
        [switchKey.full]: false,
        fullDisable: false,
        [switchKey.sidebar]: false,
        sidebarDisable: false,
        [switchKey.addin]: false,
      },
      cacheSize: ''
    }
  },

  created () {
    this.getCacheSize()
    this.getSwitchState()
  },

  methods: {
    toastReport (click) {
      report('toast', { actiontype: 2, toast: 'set', click })
    },
    getCacheSize () {
      ClientGetCacheSize().then(obj => {
        const sizeObj = bytesToSize(obj.size || 0)
        this.cacheSize = sizeObj.size + sizeObj.unit
      })
    },

    openCacheDir () { ClientOpenCachePath() },

    clearCache () {
      ClientClearCache(() => {
        this.getCacheSize()
        this.$toast({ desc: '缓存清除成功！' })
      })
    },

    getSwitchState () {
      ClientGetOfficeSetting((res) => {
        this.switchValue[switchKey.full] = res[switchKey.full]
        this.switchValue[switchKey.sidebar] = res[switchKey.sidebar]
        this.switchValue[switchKey.addin] = res[switchKey.addin]
      })
    },

    setSwitchState (flag) {
      flag && this.toastReport('3')

      this.switchValue[switchKey.full] = flag
      ClientSetOfficeAddIn(switchKey.full, flag)
    },

    changeFullStatus (flag) {
      // 侧边栏关闭， 自动展开开关自动勾选关闭，并置灰
      this.switchValue.fullDisable = flag
      this.switchValue[switchKey.full] = flag
      ClientSetOfficeAddIn(switchKey.full, flag)
    },

    setCloseSwitchState (flag) {
      this.switchValue[switchKey.sidebar] = flag
      ClientSetOfficeAddIn(switchKey.sidebar, flag)

      if (flag) {
        this.toastReport('2')
        this.changeFullStatus(flag)
      } else {
        this.switchValue.fullDisable = false
      }
    },

    setCloseOfficeSwitchState (flag) {
      this.switchValue[switchKey.addin] = flag
      ClientSetOfficeAddIn(switchKey.addin, flag)

      if (flag) {
        this.toastReport('1')

        this.changeFullStatus(flag)

        // office关闭，侧边栏自动关闭，并置灰
        this.switchValue.sidebarDisable = flag
        this.switchValue[switchKey.sidebar] = flag
        ClientSetOfficeAddIn(switchKey.sidebar, flag)
      } else {
        this.switchValue.sidebarDisable = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tools_setting_content {
  height: 100%;
  padding-left: 24px;

  .cache_box { display: flex; height: 22px; padding-top: 20px; }
  .cache_size {
    display: flex;
    align-items: center;
    margin-right: 20px;
    font-size: 14px;
    font-weight: 400;

    .label { color: $font_color_6; }
    .value { color: $font_color_3; }
  }
  .cache_btn { margin-right: 8px; }

  .sys_switch {
    height: 16px;
    font-size: 14px;
    font-weight: 400;
    color: $font_color_6;

    .title { margin: 20px 0 10px 0; font-size: 14px; font-weight: bold; color: $font_color_7; }

    .switch_item {
      display: flex;
      align-items: center;

      &+.switch_item { margin-top: 10px; }

      .switch_box {
        display: flex;
        align-items: center;

        .switch_font { margin-left: 6px; }
      }
    }
  }
}
</style>
